import { render, staticRenderFns } from "./iconMinus.vue?vue&type=template&id=850c97e4&scoped=true&"
import script from "./iconMinus.vue?vue&type=script&lang=js&"
export * from "./iconMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850c97e4",
  null
  
)

export default component.exports